import { useCallback } from "react";
import { useStateAwareNavigate } from "./useStateAwareNavigate";

/**
 * Navigates to the Schedules tab, scoped to a single template's schedules via
 * the `templateId` query param (picked up by `ServiceTemplateSchedulesPage`
 * to seed the Service filter). Mirrors `useGoToTemplate`'s navigation
 * pattern, but for the opposite direction (template -> its schedules).
 */
export function useGoToTemplateSchedules() {
    const navigate = useStateAwareNavigate();

    return useCallback(
        (templateId: string) => {
            const params = new URLSearchParams({ templateId });
            navigate(`/templates/schedules?${params.toString()}`);
        },
        [navigate],
    );
}
